<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE NEWSLETTER-->
        <div style="background: rgba(153,153,153,0.39);height: auto">
          <div class="pt-5 pb-3 row margin">
            <div class="justify-content-center row ml-0">
              <h1 class="justify-content-center row newsletter_titre_desktop">{{
                  $t('home_page.newsletter_title')
                }}</h1>  <a href="https://www.221assurances.com" target="_blank">
              <img   class="mt-1 ml-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
              </a>
            </div>

            <div class="justify-content-center row" style="padding-left: 8%">
              <input v-model="UserEmail" type="email" name="email" id="email_input"
                     :placeholder="$t('home_page.newsletter_input_placeholder')">
            </div>
            <div class="justify-content-center row" style="margin-left: 8%">
              <button style="height: 50px!important" flat class="newsletter" @click="suscribeNewsletter221()">
                <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <div>

        <!--PARITE NEWSLETTER-->
        <div style="background: rgba(153,153,153,0.39);height:auto" class="mb-5">
          <div class="justify-content-center column">
            <div class="pt-5 justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">
                {{ $t('home_page.newsletter_title') }}</h1>
            </div>

            <div class="justify-content-center row">
            <a href="https://www.221assurances.com" target="_blank">
              <img   class="mb-4" src="../../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
              </a>
          </div>

            <div class="mt-2 justify-content-center row">
              <input v-model="UserEmail" type="email" name="email" id="email_input"
                     :placeholder="$t('home_page.newsletter_input_placeholder')">
            </div>

            <div class="justify-content-center row pb-5">
              <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import ApiBrevo from '../../services/ApiBrevo';



export default {
  name: 'newsletters_section',
  components: {
    simplebar

  },
  data: () => ({
    UserEmail: null,
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    ToastTabSucess: { // Customized options for success toast
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'success',
      className: 'custom-success-class'
    },
    ToastTabError: { // Customized options for error toast
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'error'
    },
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    suscribeNewsletter221 () {
      if(this.UserEmail) {
        let newAbonne221 = {
          listIds: [23],
          email: this.UserEmail,
          updateEnabled: false
        }

        ApiBrevo().post('contacts', newAbonne221)
          .then(result => {
            console.log("result===== ", result)

            if (result.status === 201) {
              this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
              this.UserEmail = ''
            }
          }).catch((err) => {
            console.log("err==== ", err)
            this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
          }); 
      } else {
        this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221 !", this.ToastTabError);
      }        
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.newsletter_titre_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  margin-top: 6%;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}


h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}



input[type="email"] {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 300px;
  background-color: rgba(115, 115, 115, 0.58);
  color: #000;
  border-radius: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
  margin-bottom: 30px;
}

input[type="email"]::placeholder {
  color: #000;
  font-size: 20px;
}

.watch_video span {
  width: 227px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  text-transform: none;
  color: #fff;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 1.5px solid #5B94BC;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  // justify-content: center;
  align-items: center;
  // justify-content: center;
  background-color: #5B94BC;
}


.newsletter span {
  width: 200px;
  font-weight: bold;
  letter-spacing: 0px;
  font-size: 16px;
  position: relative;
  text-transform: none;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border: 2px solid #000000;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.newsletter:hover span {
  //min-width: 220px;
  border-radius: 10px;
  border: none;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #000000;
  background: #ffa409;
}



.text-lg-left {
  text-align: left !important;
}


.img-fluid {
  max-width: 100%;
  height: auto;
}




.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}


</style>

